export enum ChartZoomControlTypes {
    ECHARTS = 'echarts',
    LEAFLET = 'leaflet',
    D3 = 'd3'
}
